// extracted by mini-css-extract-plugin
export default {"avatar":"CharacterAvatar_avatar__cA7Y0","wrapper":"CharacterAvatar_wrapper__rBh1L","image":"CharacterAvatar_image__iBoIf"};